import { Header } from '@/components/layout/Header'
import { useEffect } from 'react'
import { useConfigStore } from '@/store/config'
import { HeroSection } from '@/components/home/HeroSection'
import { ValueProposition } from '@/components/home/ValueProposition'
import { FeatureModuleGrid } from '@/components/home/FeatureModuleGrid'
import { CreationPipeline } from '@/components/home/CreationPipeline'
import { PlatformSpecs } from '@/components/home/PlatformSpecs'
import { ContactSection } from '@/components/home/ContactSection'
import { HomeCtaFooter } from '@/components/home/HomeCtaFooter'

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1)
      if (id === 'contact-us') {
        setTimeout(() => {
          const element = document.getElementById(id)
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }
        }, 500)
      }
    }
  }, [])

  const scrollToWorkflow = () => {
    if (typeof window === 'undefined') {
      return
    }

    const element = document.getElementById('workflow')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const systemConfig = useConfigStore(state => state.config)
  const contactIsShow = systemConfig?.contact_is_show || false

  return (
    <div className="min-h-screen bg-black text-white selection:bg-[#07F4F2]/20">
      <div className="absolute left-0 right-0 top-0 z-50">
        <Header />
      </div>

      <HeroSection onDiscoverWorkflow={scrollToWorkflow} />
      <ValueProposition />
      <FeatureModuleGrid />
      <CreationPipeline />
      <PlatformSpecs />
      {contactIsShow && <ContactSection />}
      <HomeCtaFooter />
    </div>
  )
}
